export { default as configSlice, setConfig } from './config.slice'